<template>
  <div>
    <router-view></router-view>
    <ScrollTop/>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import ScrollTop from "@/components/app/scrollTop";

export default {
  name: "app",

  components: {
    ScrollTop
  },

  computed: {
    pageTitle() {
      return this.$store.state.pageTitle;
    }
  },

  watch: {
    pageTitle(title) {
      document.title = title;
    }
  },

  created: function() {
    window.addEventListener("storage", e => {
      if (e.key === "language" || e.key === "isUserLogged")
        window.location.reload();
    });

    document.title = this.pageTitle;
  }
};
</script>

<style>
@import "https://use.fontawesome.com/releases/v5.7.1/css/all.css";
</style>

<style lang="scss">
@import "assets/scss/main";
</style>